import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class ModalRecordButtonComponent extends Vue {

  private _clearTimeout: any;
  /**
   *
   */
  constructor() {
    super();
  }
  @Prop({ default: 0, type: Number })
  deboud?: number;
  @Prop({ default: null })
  form?: any;
  @Prop({ required: true, type: [String] })
  title?: string;
  @Prop({ type: [String] })
  icon?: string;
  @Prop({ default: 'turquoise', type: [String] })
  color?: string;
  @Prop({ default: 'primary', type: [String] })
  textColor?: string;
  @Prop({ default: 'primary', type: [String] })
  iconColor?: string;
  @Prop({ type: [Boolean], default: false })
  loading: boolean;
  @Prop({ type: [Boolean], default: false })
  disabled: boolean;
  get txtColor() {
    return this.textColor + '--text'
  }


  get coDisabled(): boolean {
    return this.disabled;
  }
  handleRecord() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      if (this.form) {
        if (this.form.validate()) {
          this.$emit('record', true);
        }
      } else {
        this.$emit('record', true)
      }
    }, this.deboud);
  }
}

export default ModalRecordButtonComponent;



// WEBPACK FOOTER //
// ./src/components/modal-record-button/index.ts